import axios from "axios";
import moment from "moment";
import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import styled from "styled-components";
import { GlobalState } from "../../GlobalState";
import WeeklyBarChart from "./WeeklyBarChart";
import { literToKiloliter, sumList } from "../utils/utils";
import Loading from "../utils/loading";
import HourlyBarChart from "./hourlyBarChart";

const GraphWrapper = styled.div`
  // margin: 1rem auto;
  // background-color: #fff;
  // padding: 1rem;
  // width: 100%;
  // // min-height: 450px;
  // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  // border-radius: 20px;

  background-color: #fff;
  height: 100%;
  padding: 1rem;
  // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  width: 100%;
  border-radius: 20px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HighLight = styled.h3`
  // color: var(--primary);
      color: #004080;
`;

const HighLight1 = styled.span`
  // color: var(--primary);
  color: #004080;
  font-weight: bold;
`;

const HourlyReport = forwardRef(({ sensor_type, sensor_id, location, startDate, endDate, reportType, timePeriod }, ref) => {
  const exportRef = useRef();
  const state = useContext(GlobalState);
  const [loading, setLoading] = useState(true);
  const [Data, setData] = useState({ dates: [], data: [], totalLitre: 0 });
  const dateFormat = "DD MMM YYYY";

  useImperativeHandle(ref, () => ({
    getElement: () => exportRef.current,
  }));

  reportType = reportType || 'Consumption';

  useEffect(() => {
    if (!startDate || !endDate || !sensor_id) return;

    const fetchData = async () => {
      try {
        const start = startDate.includes(" ") ? startDate : startDate + " 00:00:00";
        const end = endDate.includes(" ") ? endDate : endDate + " 23:59:59";

        const res = await axios.get(
          `${process.env.REACT_APP_API}/sensor/hourly_water_report?sensor_id=${sensor_id}&start_date=${start}&end_date=${end}`,
          { headers: { Authorization: state.token[0] } }
        );

        if (reportType === 'Consumption') {
          const rawDates = res.data?.consumtion?.dates || [];
          const rawData = res.data?.consumtion?.datas || [];

          const filtered = rawData
            .map((value, index) => ({
              value: Number(value),
              date: rawDates[index],
            }))
            .filter(item => item.value > 0);

          setData({
            dates: filtered.map(item => item.date),
            data: filtered.map(item => item.value),
            totalLitre: sumList(filtered.map(item => item.value)),
          });
        }else if (reportType === 'Filled') {
          const rawDates = res.data?.filled?.dates || [];
          const rawData = res.data?.filled?.datas || [];

          const filtered = rawData
            .map((value, index) => ({
              value: Number(value),
              date: rawDates[index],
            }))
            .filter(item => item.value > 0);

          setData({
            dates: filtered.map(item => item.date),
            data: filtered.map(item => item.value),
            totalLitre: sumList(filtered.map(item => item.value)),
          });
        }
        setLoading(false);
      } catch (err) {
        console.log(err.message);
        setData({ dates: [], data: [], totalLitre: 0 });
        setLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate, sensor_id, reportType, state.token]);

  if (loading) return <Loading />;

  if (!Data || !Data.data || Data.data.length === 0) {
  return (
    <GraphWrapper ref={exportRef}>
      <p>No data available for this date.</p>
    </GraphWrapper>
  );
}
  return (
    <GraphWrapper ref={exportRef}>
      <Header>
        <div>
          <HighLight>{location || "Unknown Location"}</HighLight>
           {/* <HighLight>Consumption</HighLight> */}
          <h5>
            {/* {reportType === 'Consumption' || reportType === 'Filled' ? "Approximate Consumption " : ""} */}
            {/* {sensor_type || "Water Level"} */}
              {reportType === 'Consumption'
              ? "Approximate Consumption"
              : reportType === 'Filled'
              ? "Approximate Filled"
              : ""}
            {endDate
              ? ` from ${moment(startDate).format(dateFormat)} to ${moment(endDate).format(dateFormat)}`
              : ` for ${moment(startDate).format(dateFormat)}`
            }
            <HighLight1>
              {Data.totalLitre ? ` - Total ${literToKiloliter(Data.totalLitre)}` : ""}
            </HighLight1>
          </h5>
        </div>
      </Header>

      {(reportType === 'Consumption' || reportType === 'Filled') &&
      <HourlyBarChart
          dates={Data.dates}
          water_data={Data.data}
          hourly={true}
        />
      }
    </GraphWrapper>
  );
});

export default HourlyReport;
